//@flow

import styled from "styled-components"

export type { SetScale, CoordinateConversion } from "./redux"
export {
  setScaleAndOffsets,
  currentScaleFactor,
  getContainerCoordinate,
  reducer
} from "./redux"

export default styled.div`
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -540px 0 0 -960px;
  height: 1080px;
  width: 1920px;
  background: #000;
  overflow: hidden;
  transform: scale(${({ scale }) => `${scale},${scale}`});
`



// WEBPACK FOOTER //
// ./src/Kiosk/FixedResolutionContainer/index.js